import React from "react";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";

const COLORS = ["#6366F1", "#10B981", "#F59E0B", "#EF4444", "#8B5CF6"];

const ReportCharts = ({
  opportunityTypeData,
  studentData,
  programTypeData,
  cohortData,
}) => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 px-2">
      {/* Time Logs by Opportunity Type */}
      <div className="bg-white rounded-lg shadow-md p-6">
        <h3 className="text-xl font-semibold text-gray-800 mb-4">
          Time Logs by Opportunity Type
        </h3>
        {opportunityTypeData.length > 0 ? (
          <ResponsiveContainer width="100%" height={300}>
            <PieChart>
              <Pie
                data={opportunityTypeData}
                dataKey="value"
                nameKey="name"
                cx="50%"
                cy="50%"
                outerRadius={100}
                fill="#82ca9d"
                label={({ value, name }) => (
                  <text
                    fontSize={12}
                    fill="white"
                    textAnchor="middle"
                    dominantBaseline="central"
                    x={0}
                    y={0}
                  >
                    {`${name} (${value})`}
                  </text>
                )}
                isAnimationActive={false}
              >
                {opportunityTypeData.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={COLORS[index % COLORS.length]}
                  />
                ))}
              </Pie>
              <Tooltip />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        ) : (
          <p className="text-gray-500">No data available.</p>
        )}
      </div>

      {/* Time Logs by Student */}
      <div className="bg-white rounded-lg shadow-md p-6">
        <h3 className="text-xl font-semibold text-gray-800 mb-4">
          Time Logs by Student
        </h3>
        {studentData.length > 0 ? (
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={studentData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis
                dataKey="name"
                tick={{ fontSize: 12 }}
                scale="auto"
                xAxisId={0}
              />
              <YAxis allowDecimals={false} />
              <Tooltip />
              <Legend />
              <Bar
                dataKey="value"
                fill="#6366F1"
                name="Time Logs"
                isAnimationActive={false}
              />
            </BarChart>
          </ResponsiveContainer>
        ) : (
          <p className="text-gray-500">No data available.</p>
        )}
      </div>

      {/* Time Logs by Program Type */}
      <div className="bg-white rounded-lg shadow-md p-6">
        <h3 className="text-xl font-semibold text-gray-800 mb-4">
          Time Logs by Program Type
        </h3>
        {programTypeData.length > 0 ? (
          <ResponsiveContainer width="100%" height={300}>
            <PieChart>
              <Pie
                data={programTypeData}
                dataKey="value"
                nameKey="name"
                cx="50%"
                cy="50%"
                outerRadius={100}
                fill="#FFBB28"
                label={({ value, name }) => (
                  <text
                    fontSize={12}
                    fill="white"
                    textAnchor="middle"
                    dominantBaseline="central"
                    x={0}
                    y={0}
                  >
                    {`${name} (${value})`}
                  </text>
                )}
                isAnimationActive={false}
              >
                {programTypeData.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={COLORS[index % COLORS.length]}
                  />
                ))}
              </Pie>
              <Tooltip />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        ) : (
          <p className="text-gray-500">No data available.</p>
        )}
      </div>

      {/* Time Logs by Cohort */}
      <div className="bg-white rounded-lg shadow-md p-6">
        <h3 className="text-xl font-semibold text-gray-800 mb-4">
          Time Logs by Cohort
        </h3>
        {cohortData.length > 0 ? (
          <ResponsiveContainer width="100%" height={300}>
            <PieChart>
              <Pie
                data={cohortData}
                dataKey="value"
                nameKey="name"
                cx="50%"
                cy="50%"
                outerRadius={100}
                fill="#8884d8"
                label={({ value, name }) => (
                  <text
                    fontSize={12}
                    fill="white"
                    textAnchor="middle"
                    dominantBaseline="central"
                    x={0}
                    y={0}
                  >
                    {`${name} (${value})`}
                  </text>
                )}
                isAnimationActive={false}
              >
                {cohortData.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={COLORS[index % COLORS.length]}
                  />
                ))}
              </Pie>
              <Tooltip />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        ) : (
          <p className="text-gray-500">No data available.</p>
        )}
      </div>
    </div>
  );
};

export default ReportCharts;